import To from 'await-to-js'
import Callback from '@/services/Callback'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from './instance'

export default class planDetail {
  // 拿到计划详情的任务列表
  static async initList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Activity/activity_tree_detail', payload)
    )
    return Callback(err, res)
  }
  static async askModelList(payload) {
    // 拿到所有的模型列表
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/GetModelListAsync/${payload.siteId}`)
    )
    return Callback(err, res)
  }
  static async askPaperInfo(payload) {
    // 拿到任务对应的图纸
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/activity_partlist_list/${payload.activityId}`)
    )
    return Callback(err, res)
  }
  static async askCalendar(payload) {
    // 拿到任务对应的图纸
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/getactivitycalendarlist/${payload.activityId}`)
    )
    return Callback(err, res)
  }
  static async exportExcel(payload) {
    // 导出excel
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/activity_export_excel/${payload.activityId}`)
    )
    return Callback(err, res)
  }
  // 获取进度模拟数据
  static async getActivityModel(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        encodeUrl(
          `/api/Activity/get_fived_simulation_list/${payload.processId}/${payload.activityId}/${payload.startTime}/${payload.finishDate}/${payload.actualStartDate}/${payload.actualEndDate}`
        )
      )
    )
    return Callback(err, res)
  }
}
